module.exports = __webpack_public_path__ + "static/media/cf.1bc217dc.svg";